// extracted by mini-css-extract-plugin
export var wrapper = "g_b";
export var show = "g_S";
export var content = "g_F";
export var navigation = "g_T";
export var address = "g_V";
export var form = "g_W";
export var heading = "g_G";
export var box = "g_L";
export var link = "g_X";
export var external = "g_Y";